import { HttpEvent, HttpEventType } from "@angular/common/http";
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from "@angular/core";
import { Observable } from "rxjs";
import { VideoEvent } from "../video-player/video-player.component";
import { VideoProcessTO } from "./model/video-process.model";
import { VideoProcessService } from "./services/video-process.service";

@Component({
    selector: "video-in-process",
    templateUrl: "./video-in-process.component.html",
    styleUrls: ["./video-in-process.component.scss"]
})
export class VideoInProcessComponent implements OnInit, OnDestroy, OnChanges {
    public videoProcess: VideoProcessTO | null = null;
    private static regexGuid = /^[0-9A-Fa-f\-]{36}$/g;

    public uploading = false;
    public uploadPercentage = 0;
    public uploadErro = false;

    public videoProcessing = () =>
        this.uploading == false &&
        this.uploadErro == false &&
        this.videoProcess != null &&
        this.videoProcess?.errorCode == null &&
        this.videoProcess?.concluido == false;

    public videoProcessErro = () =>
        this.uploading == false &&
        this.uploadErro == false &&
        this.videoProcess != null &&
        this.videoProcess.errorCode != null &&
        this.videoProcess?.concluido == true;

    public inConversionQueue = () =>
        this.uploading == false &&
        this.uploadErro == false &&
        this.jobId != null &&
        this.videoProcessing() == false &&
        this.videoProcessErro() == false &&
        this.videoProcess?.concluido != true;

    public showVideoPlayer = () =>
        !this.uploading &&
        !this.uploadErro &&
        !this.videoProcessing() &&
        !this.videoProcessErro() &&
        !this.inConversionQueue() &&
        ((this.src != null && this.src.length > 0) || this.externalMediaUrl?.length > 0);

    @Input() blockAdvanceVideo: boolean;

    @Input("interval")
    private interval = 5 * 1000; // 5 s

    @Input("job-id")
    jobId: string;

    @Input("upload-observable")
    public uploadObservable: Observable<HttpEvent<any>>;

    @Output("video-complete")
    private emitVideoComplete = new EventEmitter<boolean>();

    @Output("upload-complete")
    private emitUploadComplete = new EventEmitter<boolean>();

    @Input("src")
    public src: string[] = [];

    @Input("thumbnail")
    public thumbnail: string = null;

    @Input("externalMediaUrl")
    public externalMediaUrl?: string;

    @Input("InitialTimeInSec") initialTimeInSec: number;
    @Output("VideoEvent") videoEventEmitter = new EventEmitter<VideoEvent>();
    @Output("videoProcessError") videoProcessErroEmitter = new EventEmitter<boolean>();
    @Output("videoProcessing") videoProcessingEmitter = new EventEmitter<boolean>();
    @Output("inConversionQueue") inConversionQueueEmitter = new EventEmitter<boolean>();

    public gif: string;
    private timeInterval: any;

    private uploadSampleLoadedBitsStart = 0;
    private uploadSampleLoadedBitsEnd = 0;
    private uploadSampleLoadedTime = null;
    private uploadSampleTimer;
    public uploadSpeed = 0;

    private static emitVideoCompleteList: string[] = [];

    private gifs: string[] = [
        "assets/images/gurumatch-video-processing-f.gif",
        "assets/images/gurumatch-video-processing-m.gif"
    ];

    constructor(private videoProcessService: VideoProcessService) {
        this.gif = this.gifs[Math.floor(Math.random() * this.gifs.length)];
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.jobId && changes.jobId.currentValue != changes.jobId.previousValue) {
            this.changesJobId();
        }

        if (
            changes.uploadObservable &&
            changes.uploadObservable.currentValue != changes.uploadObservable.previousValue
        ) {
            this.processSubscriptionUpload(changes.uploadObservable.currentValue as Observable<HttpEvent<any>>);
        }
    }

    ngOnDestroy(): void {
        if (this.timeInterval) clearInterval(this.timeInterval);
    }

    ngOnInit() {
        this.processSubscription();
    }

    processSubscription(): void {
        this.videoProcessService.videoProcessAsync().subscribe((videoProcess) => {
            this.videoProcess = videoProcess[this.jobId];
            this.videoProcessErroEmitter.emit(this.videoProcessErro());
            this.videoProcessingEmitter.emit(this.videoProcessing());
            this.inConversionQueueEmitter.emit(this.inConversionQueue());

            if (
                this.videoProcess &&
                this.videoProcess.concluido &&
                (this.videoProcess.save || !this.videoProcess.errorMessage)
            ) {
                if (VideoInProcessComponent.emitVideoCompleteList.find((a) => a == this.jobId) != null) {
                    if (this.timeInterval) {
                        clearInterval(this.timeInterval);
                        this.timeInterval = null;
                    }

                    // dispara evento duplicado
                    console.log("Evento discartado " + this.jobId);
                    return;
                }

                VideoInProcessComponent.emitVideoCompleteList.push(this.jobId);
                // Aguarda MongoDB Efetivar Mudança
                setTimeout(() => {
                    this.emitVideoComplete.emit(true);
                }, 2000);

                if (this.timeInterval) {
                    clearInterval(this.timeInterval);
                    this.timeInterval = null;
                }
            }
        });
    }

    processSubscriptionUpload(upload: Observable<HttpEvent<any>>) {
        if (upload == null) {
            this.uploadPercentage = 0;
            this.uploading = false;
            return;
        }

        this.uploadPercentage = 0;
        upload.subscribe(
            (resp) => {
                if (resp == null) {
                    this.uploading = false;
                    this.uploadErro = false;
                    return;
                }

                if (!this.uploading) {
                    this.StartUpload();
                }

                if (resp.type === HttpEventType.Response) {
                    this.uploadPercentage = 100;

                    if (this.uploading) {
                        // Agudarda Mongo Efetivar Upload
                        setTimeout(() => {
                            this.emitUploadComplete.emit(true);
                        }, 2000);
                    }

                    if (resp.status >= 400) this.uploadErro = true;

                    this.EndUpload();
                    return;
                }

                if (resp.type == HttpEventType.UploadProgress) {
                    if (this.jobId != null) {
                        this.jobId = null;
                    }
                    this.uploadSampleLoadedBitsEnd = resp.loaded;

                    this.uploadPercentage = Math.round((resp.loaded / resp.total) * 100);
                    return;
                }
            },
            (err) => {
                if (this.uploading) {
                    this.uploadErro = true;
                    this.emitUploadComplete.emit(true);
                    this.EndUpload();
                }
            }
        );
    }

    private StartUpload() {
        if (this.timeInterval) {
            clearInterval(this.timeInterval);
            this.timeInterval = null;
        }

        this.jobId = null;
        this.uploading = true;
        this.uploadErro = false;

        this.uploadSampleLoadedTime = new Date().valueOf();
        this.uploadSampleLoadedBitsStart = 0;
        this.uploadSampleLoadedBitsEnd = 0;

        if (this.uploadSampleTimer) clearInterval(this.uploadSampleTimer);
        this.uploadSampleTimer = setInterval(() => {
            this.CalcUploadSeepd();
        }, 3 * 1000);
    }

    private EndUpload() {
        this.uploading = false;
        this.uploadSampleLoadedBitsStart = 0;
        this.uploadSampleLoadedBitsEnd = 0;
        if (this.uploadSampleTimer) clearInterval(this.uploadSampleTimer);
    }

    private CalcUploadSeepd() {
        // Captura
        const uploadSampleLoadedBits = this.uploadSampleLoadedBitsEnd - this.uploadSampleLoadedBitsStart;
        const time = new Date().valueOf() - this.uploadSampleLoadedTime;

        // Registra
        this.uploadSampleLoadedBitsStart = this.uploadSampleLoadedBitsEnd;
        this.uploadSampleLoadedTime = new Date().valueOf();

        // Calcula
        this.uploadSpeed = uploadSampleLoadedBits / (time / 1000);
    }

    private changesJobId() {
        if (this.jobId != null && this.jobId.match(VideoInProcessComponent.regexGuid) == null) {
            // console.log("jobid old", this.jobId);
            this.jobId = null;
            return;
        }

        this.videoProcess = null;

        if (this.timeInterval) clearInterval(this.timeInterval);
        this.videoProcessService.getVideoProcess(this.jobId);
        this.timeInterval = setInterval(() => {
            if (this.jobId) {
                this.videoProcessService.getVideoProcess(this.jobId);
            }
        }, this.interval);
    }

    /**
     * Format bytes as human-readable text.
     *
     * @param bytes Number of bytes.
     * @param si True to use metric (SI) units, aka powers of 1000. False to use
     *           binary (IEC), aka powers of 1024.
     * @param dp Number of decimal places to display.
     *
     * @return Formatted string.
     */
    public humanFileSize(bytes, si = false, dp = 1) {
        const thresh = si ? 1000 : 1024;

        if (Math.abs(bytes) < thresh) {
            return bytes + " B";
        }

        const units = si
            ? ["kB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]
            : ["KiB", "MiB", "GiB", "TiB", "PiB", "EiB", "ZiB", "YiB"];
        let u = -1;
        const r = 10 ** dp;

        do {
            bytes /= thresh;
            ++u;
        } while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);

        return bytes.toFixed(dp) + " " + units[u];
    }
}
